module.exports = __webpack_public_path__ + "static/img/boyo.59d72cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/boyo.png
// module id = NMmx
// module chunks = 2